import intlTelInput from 'intl-tel-input';
import * as countries from 'intl-tel-input/i18n';
export default class PhoneInputService {
    initPhoneInputs() {
        const phoneInputs = document.querySelectorAll('.input-tel');
        phoneInputs.forEach((phoneInput) => {
            var _a, _b;
            if (!phoneInput)
                return;
            let lang = (_b = (_a = window === null || window === void 0 ? void 0 : window.perlaData) === null || _a === void 0 ? void 0 : _a.language) !== null && _b !== void 0 ? _b : '';
            if (['uk'].includes(lang)) {
                lang = 'ua';
            }
            else if (['en', ''].includes(lang)) {
                lang = 'gb';
            }
            const iti = intlTelInput(phoneInput, {
                i18n: countries[lang],
                initialCountry: lang,
                autoPlaceholder: 'polite',
            });
            const onCountryChange = () => {
                var _a, _b;
                if (((_a = iti.getSelectedCountryData()) === null || _a === void 0 ? void 0 : _a.dialCode) && !phoneInput.value) {
                    iti.setNumber(`+${(_b = iti.getSelectedCountryData()) === null || _b === void 0 ? void 0 : _b.dialCode}`);
                }
            };
            setTimeout(() => {
                try {
                    if (!phoneInput.value) {
                        onCountryChange();
                    }
                }
                catch (e) {
                    console.log(e);
                }
            }, 400);
            phoneInput.addEventListener('countrychange', onCountryChange);
            try {
                const phoneWrapper = phoneInput.parentElement;
                const inputContainer = phoneWrapper === null || phoneWrapper === void 0 ? void 0 : phoneWrapper.parentElement;
                const label = inputContainer === null || inputContainer === void 0 ? void 0 : inputContainer.querySelector('label');
                if (!label || !phoneWrapper)
                    return;
                const newLabel = label.cloneNode(true);
                phoneWrapper.appendChild(newLabel);
                label.remove();
            }
            catch (e) {
                console.log(e);
            }
            const inputContainer = phoneInput.closest('.input-container');
            const onPhoneInput = () => {
                var _a;
                if (!inputContainer) {
                    return;
                }
                const phoneRegex = /^[+\d]?[0-9\s\-()]+$/;
                const dialCode = (_a = iti.getSelectedCountryData()) === null || _a === void 0 ? void 0 : _a.dialCode;
                const hasDialCode = phoneInput === null || phoneInput === void 0 ? void 0 : phoneInput.value.trim().startsWith(`+${dialCode}`);
                if (!phoneRegex.test(iti.getNumber() || phoneInput.value) || !hasDialCode) {
                    inputContainer.classList.add('error');
                }
                else {
                    inputContainer.classList.remove('error');
                }
            };
            phoneInput === null || phoneInput === void 0 ? void 0 : phoneInput.addEventListener('blur', onPhoneInput);
            phoneInput === null || phoneInput === void 0 ? void 0 : phoneInput.addEventListener('beforeinput', onPhoneInput);
            phoneInput === null || phoneInput === void 0 ? void 0 : phoneInput.addEventListener('input', (e) => {
                var _a;
                const el = e.target;
                const oldValue = (_a = el.value) !== null && _a !== void 0 ? _a : '';
                let newValue = oldValue.replace(/[^+\d\s\-()]/g, '').trim();
                if (newValue.length > 16) {
                    newValue = newValue.slice(0, 16);
                }
                if (oldValue !== newValue) {
                    el.value = newValue;
                }
            });
        });
    }
    init() {
        this.initPhoneInputs();
    }
}
